import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  loaderIsActive = signal(false);
  public requestsUrls: string[] = [];
  
  constructor() {}
  
  show(url:string): void {
    this.requestsUrls.push(url);
    if(this.requestsUrls.length === 1){
      this.loaderIsActive.set(true);
    }
  }

  hide(url:string): void {
    const index = this.requestsUrls.indexOf(url);
    if(index !== -1){
      this.requestsUrls.splice(index, 1);
    }
    if(this.requestsUrls.length === 0 ){
      this.loaderIsActive.set(false);
    }
  }


}
